import { Component, Input } from '@angular/core';

@Component({
  selector: 'markant-platform-management-tile-cancellation',
  templateUrl: './cancellation.component.html',
  styleUrls: ['./cancellation.component.scss'],
})
export class CancellationManagementTileComponent {
  @Input({ required: true }) serviceId!: string;

  isCancelProcessDialogOpen = false;
  bookingId?: string;

  openCancelProcessDialog(bookingId: string): void {
    this.bookingId = bookingId;
    this.isCancelProcessDialogOpen = true;
  }

  closeDialog(): void {
    this.isCancelProcessDialogOpen = false;
  }
}
